module.exports = __webpack_public_path__ + "img/1F1F0-1F1F2.a71fd8cc.svg";